/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTeamMemberListQuery } from '@gen2/api/team-member/hooks';
import { PermissionsKeys } from '@gen2/types/permissions';
import { SearchCondition } from '@gen2/types/search-condition';
import { TBasicUser } from '@gen2/types/user';
import { useEffect, useMemo, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
import { useSendInviteStore } from './store';

export const useAssignee = () => {
  const initialSearchCondition: SearchCondition = useMemo(
    () => ({
      'sort[column]': 'first_name',
      'sort[order]': 'asc',
      'filter[active]': 1,
      'filter[permission]': [PermissionsKeys.SHOW_INVITE_ASSIGNEE],
      per_page: 10,
      page: 1,
    }),
    [],
  );
  const [selectedAssignee, setSelectedAssignee] = useState<TBasicUser[]>([]);

  const { invite } = useSendInviteStore();
  const [searchAssignee, setSearchAssignee] = useState('');
  const [debouncedValue] = useDebounceValue(searchAssignee, 300);
  const [searchCondition, setSearchCondition] = useState(
    initialSearchCondition,
  );

  const { data: users, isLoading: isUsersLoading } =
    useTeamMemberListQuery(searchCondition);

  const optionsAssignee = useMemo(() => {
    if (!users?.data) return [];

    return users.data as TBasicUser[];
  }, [users]);

  // update default selected point of contact when invite is stored
  useEffect(() => {
    if (invite?.assignee_user) {
      setSelectedAssignee([invite.assignee_user]);
    }
  }, [invite]);

  useEffect(() => {
    if (debouncedValue) {
      setSearchCondition((prev) => ({
        ...prev,
        'filter[search]': debouncedValue,
      }));
    } else {
      setSearchCondition(initialSearchCondition);
    }
  }, [debouncedValue, initialSearchCondition]);

  return {
    optionsAssignee,
    isUsersLoading,
    selectedAssignee,
    setSelectedAssignee,
    setSearchAssignee,
  };
};
